// extracted by mini-css-extract-plugin
export default {"spinner":"spinner___jcUUD","spinner-border":"spinner-border___2f_1P","spinnerBorder":"spinner-border___2f_1P"};